<template>
  <div
    class="tw-p-3 tw-flex tw-flex-col tw-items-center tw-bg-gray-100 tw-rounded-xl tw-rounded-b-none"
  >
    <div class="handle tw-rounded tw-mb-4"></div>
    <div v-if="title" class="tw-font-medium tw-mb-8 tw-text-center">
      {{ title }}
    </div>
    <ul class="tw-inline-block tw-mb-4 tw-w-[80%]">
      <li
        v-for="(option, index) in options"
        :key="index"
        class="tw-list-none tw-flex tw-mb-3 hover:tw-cursor-pointer"
        @click="option.onClick"
      >
        <component
          :is="option.icon"
          :class="{ 'tw-text-2xl': option.description }"
          class="tw-mr-2"
        />
        <div>
          <div class="tw-font-medium">{{ option.title }}</div>
          <div v-if="option.description" class="tw-text-sm">
            {{ option.description }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
  },
}
</script>

<style>
.handle {
  width: 50vw;
  height: 3px;
  background-color: #424242;
}
</style>
